import { render, staticRenderFns } from "./personAll.vue?vue&type=template&id=0537a133&scoped=true&"
import script from "./personAll.vue?vue&type=script&lang=js&"
export * from "./personAll.vue?vue&type=script&lang=js&"
import style0 from "./personAll.vue?vue&type=style&index=0&id=0537a133&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0537a133",
  null
  
)

export default component.exports